import type { GraphQLResponse } from 'relay-runtime';

import {
	BadStatusError,
	isSessionExpiredError,
	NoNetworkError,
	causedByAbortError,
} from '@confluence/network';
import {
	getNetworkStatus,
	setNetworkStatus,
	ClientNetworkStatus,
} from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache';

export const updateNetworkStatusUnlessSessionExpired = (newStatus: ClientNetworkStatus) => {
	const currentStatus = getNetworkStatus();
	if (newStatus === currentStatus || currentStatus === ClientNetworkStatus.SESSION_EXPIRED) {
		return;
	}
	setNetworkStatus(newStatus);
};

export const isIpBlockedError = (error: Error): error is BadStatusError => {
	return error instanceof BadStatusError && error.response.status === 403;
};

export const isRateLimitedError = (error: Error): error is BadStatusError => {
	return error instanceof BadStatusError && error.response.status === 429;
};

export const shouldTreatAsOfflineError = (error: Error): error is NoNetworkError => {
	return error instanceof NoNetworkError && !error.ignore && !causedByAbortError(error);
};

export const hasSessionExpiredErrors = (result: GraphQLResponse): boolean => {
	const errors = 'errors' in result ? result.errors : undefined;
	if (!errors || errors.length === 0) {
		return false;
	}
	return errors.some((error) => {
		return isSessionExpiredError(error);
	});
};
